import { Component } from '@angular/core';

@Component({
  selector: 'cdfl-addqualified',
  templateUrl: './addqualified.component.html',
  styleUrls: ['./addqualified.component.scss']
})
export class AddqualifiedComponent {

}
